<template>
  <div class="page_warp">
    <div class="top_content">
      <div class="top_input">
        <el-input placeholder="请输入"></el-input>
      </div>
      <div class="search_btn" @click="getData">查询</div>
      <div class="add_btn" @click="add">添加</div>
    </div>
    <div class="bottom_content">
      <div class="table_container" v-bind:id="tableId">
        <el-table
          v-bind:data="tableData"
          stripe
          border
          style="width: 100%"
          v-bind:max-height="tableHeight"
          v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }"
          v-bind:cell-style="{ textAlign: 'center' }"
          empty-text="暂无数据"
        >
          <!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
          <el-table-column prop="roleName" label="计划单号"></el-table-column>
          <el-table-column prop="roleRemark" label="托运商"></el-table-column>
          <el-table-column prop="roleCreName" label="供应商"></el-table-column>
		  <el-table-column prop="roleCreName" label="装货地名称"></el-table-column>
		  <el-table-column prop="roleCreName" label="货品"></el-table-column>
		  <el-table-column prop="roleCreName" label="计划装货时间"></el-table-column>
		  <el-table-column prop="roleCreName" label="需求车数"></el-table-column>
		  <el-table-column prop="roleCreName" label="已确认车数"></el-table-column>
		  <el-table-column prop="roleCreName" label="状态"></el-table-column>
		  <el-table-column prop="roleCreName" label="卸货地名称"></el-table-column>
		  <el-table-column prop="roleCreName" label="备注"></el-table-column>
          <el-table-column
            prop="roleCretime"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <span
                class="default_color pointer m-right10"
                v-on:click="edit(scope.row.roleId)"
                >编辑</span
              >
              <span
                class="default_color pointer m-right10"
                v-on:click="detail(scope.row.roleId)"
                >详情</span
              >
              <span
                class="col-FF1A1A pointer"
                v-on:click="del(scope.row.roleId)"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-y-center flex-x-center">
        <el-config-provider :locale="locale">
          <el-pagination
            background
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[5, 10, 15, 20]"
            layout="sizes, prev, pager, next, total, jumper"
            :total="totalCount"
            @size-change="getData"
            @current-change="getData"
          />
        </el-config-provider>
      </div>
    </div>

    <Add ref="addRef" v-if="isAdd" @getData="getData" />
    <Edit ref="editRef" v-if="isEdit" @getData="getData" />
    <Detail ref="detailRef" v-if="isDetail" @getData="getData" />
    <!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  onMounted,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
import Add from "./components/add";
import Edit from "./components/edit";
import Detail from "./components/detail";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default defineComponent({
  components: { Add, Edit, Detail },
  name: "waybillPlan",
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    const data = reactive({
      tableId: "roleManagementTable",
      page: 1,
      pageSize: 10,
      searchWord: "",
      totalCount: 0,
      tableData: [],
      tableHeight: 0,
      isAdd: false,
      isEdit: false,
      isDetail: false,
      sendData: null,
      locale: zhCn,
    });
    onMounted(() => {
      console.log(store.state.userInfo);
      nextTick(() => {
        data.tableHeight =
          document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight - 40;
        getData();
      });
      window.onresize = () => {
        nextTick(() => {
          var offsetHeight = document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight;
          if (offsetHeight <= 0) {
            return false;
          }
          data.tableHeight = document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight;
        });
      };
    });
    //获取列表数据
    const getData = async () => {
      let params = {
        searchWord: data.searchWord,
        page: data.page,
        limit: data.pageSize,
        // roleOrg: store.state.userInfo.orgId,
      };
      const r = await proxy.$http.get(apiObj.roleList, params);
      console.log(r);
      if (r.code === 0) {
        data.tableData = r.rows;
        data.totalCount = r.total;
      }
    };

    // 添加 根目录
    const add = () => {
      data.isAdd = true;
      nextTick(() => {
        proxy.$refs.addRef.init();
      });
    };

    // 菜单编辑
    const edit = (id) => {
      data.isEdit = true;
      nextTick(() => {
        proxy.$refs.editRef.init(id);
      });
    };
    // 菜单详情
    const detail = (id) => {
      data.isDetail = true;
      nextTick(() => {
        proxy.$refs.detailRef.init(id);
      });
    };
    //菜单删除
    const del = (roleId) => {
      proxy
        .$confirm("您确定删除选中的数据吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let params = {
            roleId: roleId,
          };
          const r = await proxy.$http.post(apiObj.roleDel, params);
          if (r.respCode == 0 || r.respCode == "0000") {
            proxy.$message.success(r.msg || r.respMsg);
            getData();
          } else {
            proxy.$message.error(r.msg || r.respMsg);
          }
        });
    };

    return {
      ...toRefs(data),
      getData,
      add,
      edit,
      detail,
      del,
    };
  },
});
</script>

<style scoped>
.page_warp {
  width: 100%;
  height: 100%;
}
</style>
